/**
 * Keyboard focus for the branded line sheet's dialogs (KP-4545, KP-4572):
 * Tab and Shift+Tab wrap inside the dialog instead of leaving it.
 */

export const FOCUSABLE = 'button:not([disabled]), [href], input:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'

/** Wraps a Tab keydown inside container. */
export function trapTab(container, event) {
  if (!container) return
  const nodes = [...container.querySelectorAll(FOCUSABLE)]
  if (!nodes.length) return
  const first = nodes[0]
  const last = nodes[nodes.length - 1]
  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault()
    last.focus()
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault()
    first.focus()
  }
}
